/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_StreetInputs */

const cs_addr_field_street = /** @type {(inputs: Addr_Field_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulice`)
};

const en_addr_field_street = /** @type {(inputs: Addr_Field_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Addr_Field_StreetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_street = /** @type {((inputs?: Addr_Field_StreetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_StreetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_street(inputs)
	return cs_addr_field_street(inputs)
});